let diamondAttrMaps = {
    'Cut': {
        'FR': 'Fair',
        'GD': 'Good',
        'VG': 'Very Good',
        'ID': 'Ideal',
        '': 'Super Ideal',
        'EX': 'Excellent',
    },
    'Polish': {
        'GD': 'Good',
        'VG': 'Very Good',
        'EX': 'Excellent'
    },
    'Symm': {
        'GD': 'Good',
        'VG': 'Very Good',
        'EX': 'Excellent'
    }
}
let ringsOptionsMaps = {
    'style': {
        'Solitaire': 'SO',
        'Pavé': 'PV',
        'Three Stone': 'TS',
        'Halo': 'HL',
        'Hidden Halo': 'HH',
        'Bezel': 'BZ',
        'Side-Stone': 'SS',
        'Channel Set': 'CS',
        'Vintage': 'VT',
        'Cathedral': 'CT',
        'Floral': 'FL',
        'Cluster': 'CL',
        'Tension': 'TN',
        'Bridal Sets': 'BS',
        'Unique': 'UN',
        'Milgrain': 'MI',
    },
    metal: {
        'Platinum': '14WG',
        '18K Yellow Gold': '18YG',
        '18K White Gold': '18WG',
        '14K Rose Gold': '14RG',
        '14K Yellow Gold': '14YG',
        '14K White Gold': '14WG',
    },
    shape: {
        'Round': 'RD',
        'Oval': 'OV',
        'Pear': 'PE',
        'Cushion': 'CU',
        'Marquise': 'MQ',
        'Emerald': 'EM',
        'Radiant': 'RA',
        'Asscher': 'AS',
        'Princess': 'PR',
        'Heart': 'HT',
        'Elongated Cushion': 'EC',
    }
}

function getSettingName(title, item) {
    return `${title} ${item.option1} Diamond Ring in ${item.option2} ${item.option3}`
}

function getPriceStr(price) {
    return new Intl.NumberFormat(Shopify.locale, {
        style: 'currency',
        currency: 'USD',
        minimumFractionDigits: 2
    }).format(price)
}

function getSkuFromDesc(desc) {
    return desc.match(/SKU:[\s\S]*?(?:<[^>]+>)*([^<\s]+)/)?.[1] || '';
}

function getRingsMediaUrlName(sku, style, metal, shape) {
    return `${sku}_${ringsOptionsMaps.style[style]}${ringsOptionsMaps.metal[metal]}${ringsOptionsMaps.shape[shape]}`;
}

function getRingsImageName(sku, item) {
    return `${sku}_${ringsOptionsMaps.style[item.option1]}${ringsOptionsMaps.metal[item.option2]}${ringsOptionsMaps.shape[item.option3]}`;
}

function getMediaData(product, item) {
    const mediaData = [];
    for (let i = 1; i <= 5; i++) {
        const ext = 'jpg';
        const host = 'https://cdn.shopify.com/s/files/1/0676/6716/5443/files';
        const img = `${host}/${getRingsImageName(product.sku, item)}_${i}.${ext}`;
        mediaData.push(img)
    }
    return mediaData
}


// 初始化心愿单
const parseWishlist = (str) => {
    return str.split(',')                     // 分割字符串为数组
        .filter(Boolean)                        // 过滤空值
        .map(item => item.trim())               // 去除前后空格
        .filter(item => item.startsWith('id:')) // 过滤合法格式
        .reduce((acc, cur) => {
            const id = String(cur.split(':')[1]);         // 提取纯数字ID
            acc[id] = true;
            return acc;
        }, {});
};

let wishlistObj = parseWishlist(localStorage.getItem('t4s_wis') || '');
const $wishlist = $('.t4s-site-nav__heart');
$wishlist.find('.t4s-count-box').text(Object.keys(wishlistObj).length)

function checkWishList(id) {
    return wishlistObj[String(id)] === true
}

//添加心愿单
function addWishList(id) {
    wishlistObj[String(id)] = true;
    localStorage.setItem('t4s_wis', serializeWishlist(wishlistObj));
    $wishlist.find('.t4s-count-box').text(Object.keys(wishlistObj).length)
}

function removeWishList(id) {
    delete wishlistObj[String(id)]
    localStorage.setItem('t4s_wis', serializeWishlist(wishlistObj));
    $wishlist.find('.t4s-count-box').text(Object.keys(wishlistObj).length)
}

function serializeWishlist(obj) {
    return Object.keys(obj)
        .filter(id => typeof id === 'string') // 过滤合法格式
        .map(id => `id:${id}`)
        .join(',')
}


// 初始化心愿单
let diamondList = parseWishlist(localStorage.getItem('diamondList') || '');

function checkDiamondList(id) {
    return diamondList[String(id)] === true
}

function addDiamondList(id) {
    diamondList[String(id)] = true;
    localStorage.setItem('diamondList', serializeWishlist(diamondList));
}

function removeDiamondList(id) {
    delete diamondList[String(id)]
    localStorage.setItem('diamondList', serializeWishlist(diamondList));
}

// 计算的日期并格式化
function getFormattedDateAfterDays(days) {
    // 创建当前日期对象
    const today = new Date();

    // 计算的日期
    const futureDate = new Date(today);
    futureDate.setDate(today.getDate() + days);
    // 星期缩写映射表
    const weekdays = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
    // 月份缩写映射表
    const months = [
        'Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun',
        'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'
    ];
    // 获取日期组件
    const dayName = weekdays[futureDate.getDay()];
    const monthName = months[futureDate.getMonth()];
    const date = futureDate.getDate();

    // 格式化输出
    return `${dayName}, ${monthName} ${date}`;
}

$('.ship-date').text(getFormattedDateAfterDays(10))
$('#size_receive_by').text(getFormattedDateAfterDays(10))

// 心愿单-end

function isMobileDevice() {
    const ua = navigator.userAgent;
    const screenWidth = window.innerWidth;
    // 用户代理关键词检测 (覆盖主流移动平台)
    const mobileUAKeywords = [
        'Android', 'webOS', 'iPhone', 'iPad', 'iPod',
        'BlackBerry', 'Windows Phone', 'IEMobile',
        'Opera Mini', 'Mobile'
    ];
    // 平板检测 (可根据需求调整)
    const isTablet = /iPad|Android|Tablet/i.test(ua) &&
        screenWidth > 480 && screenWidth <= 1024;
    // 核心判断逻辑
    return (
        // 用户代理匹配移动端关键词
        mobileUAKeywords.some(keyword => ua.includes(keyword)) ||
        // 屏幕宽度检测 (阈值可调整)
        screenWidth < 768 ||
        // 触摸屏特性检测
        ('ontouchstart' in window || navigator.maxTouchPoints > 0) ||
        // 移动端操作系统检测
        /Macintosh/.test(ua) && 'ontouchstart' in window // 部分iPad
    ) && !isTablet; // 排除平板 (根据需求可选)
}

// 初始化状态
let isMobile = isMobileDevice();
// 监听窗口变化
window.addEventListener('resize', () => {
    isMobile = isMobileDevice();
});

if (isMobile) {
    $('.view-phone').show()
    $('.view-pc').hide()
} else {
    $('.view-phone').hide()
    $('.view-pc').show()
}
window.addEventListener('resize', () => {
    isMobile = isMobileDevice();
    if (isMobile) {
        $('.view-phone').show()
        $('.view-pc').hide()
    } else {
        $('.view-phone').hide()
        $('.view-pc').show()
    }
});


function showTips(msg) {
    $('.layout-show-tips').show().find('.avenir-heavy').text(msg)
}

$('.tips-close').click(function () {
    $(this).parent().parent().hide();
    $(this).siblings().find('.avenir-heavy').text('');
})

// 购物车
async function addMultipleToCart(products) {
    try {
        window.ultimateShopifyDataLayer.designing = true
        for (const product of products) {
            const $ret = await fetch('/cart/add.js', {
                method: 'POST',
                headers: {'Content-Type': 'application/json'},
                body: JSON.stringify(product)
            });
            // console.debug('addMultipleToCart', $ret)
        }
        window.ultimateShopifyDataLayer.designing = false
        return true;
    } catch (err) {
        console.error('addMultipleToCart', err)
        window.ultimateShopifyDataLayer.designing = false
        return false;
    }
}

async function cartChange(products) {
    for (const product of products) {
        const $ret = await fetch('/cart/change.js', {
            method: 'POST',
            headers: {'Content-Type': 'application/json'},
            body: JSON.stringify(product)
        });
        // console.debug($ret)
    }
}

async function getCarts() {
    const $ret = await fetch('/cart.js');
    return $ret.json()
}

// 调用示例（包含不同属性和数量）
// const products = [
//     { id: 123456, quantity: 1, properties: { Size: 'M' } },
//     { id: 789012, quantity: 2, properties: { Color: 'Red' } }
// ];
// 购物车-end


function extractJSON(str) {
    try {
        // 匹配 JSON 对象
        const jsonMatch = str.match(/\{[\s\S]*\}/);
        if (!jsonMatch) throw new Error("未找到 JSON 数据");

        // 处理转义字符
        const rawJson = jsonMatch[0]
            .replace(/\\\//g, '/')    // 转换 URL 斜杠
            .replace(/\\\\/g, '\\');  // 保留有效反斜杠

        return JSON.parse(rawJson);
    } catch (error) {
        console.error("解析失败:", error.message);
        return null;
    }
}

// 初始化滑块
function initSliderHand(selector) {
    // 获取滑块容器元素
    const sliderContainer = $(selector);
    if (!sliderContainer) return;

    // 获取滑块相关元素
    const sliderTrack = sliderContainer.find('.noUi-base');
    const sliderHandle = sliderContainer.find('.noUi-origin');
    const sliderConnects = sliderContainer.find('.noUi-connects');

    // 获取图片元素
    const darkHand = sliderContainer.parent().parent().find('.dark-base-hand');
    const darkHand2 = sliderContainer.parent().parent().find('.dark-base-hand2');

    // 设置滑块初始状态
    let isDragging = false;
    let currentPosition = 100; // 初始位置在底部 (100%)

    // 更新滑块位置和图片效果
    function updateSlider(position) {
        // 限制位置在0-100%之间
        position = Math.max(0, Math.min(100, position));
        currentPosition = position;

        // 更新滑块位置
        sliderHandle.css('transform', `translate(0px, ${position}%)`);

        // 更新连接区域（进度条）
        sliderConnects.css('height', `${100 - position}%`);
        sliderConnects.css('top', `${position}%`);

        // 计算透明度值 (0-1)
        const opacity = (100 - position) / 100;

        // 更新图片透明度
        darkHand.css('opacity', opacity);
        darkHand2.css('opacity', opacity);
    }

    // 鼠标/触摸事件处理
    function handleStart(e) {
        e.preventDefault();
        isDragging = true;
        sliderHandle.addClass('noUi-active');
    }

    function handleMove(e) {
        if (!isDragging) return;

        // 获取鼠标/触摸位置
        const clientY = getClientY(e);
        if (!clientY) return;

        // 计算滑块位置
        const trackRect = sliderTrack[0].getBoundingClientRect();
        const position = ((clientY - trackRect.top) / trackRect.height) * 100;
        // 更新滑块
        updateSlider(position);
    }

    function handleEnd() {
        isDragging = false;
        sliderHandle.addClass('noUi-active');
    }

    // 添加事件监听器
    sliderHandle.on('mousedown touchstart', handleStart);
    $(document).on('mousemove touchmove', handleMove);
    $(document).on('mouseup touchend', handleEnd);

    // 添加点击滑道跳转功能
    sliderTrack.on('click', function (e) {
        const trackRect = this.getBoundingClientRect();
        const position = ((e.clientY - trackRect.top) / trackRect.height) * 100;
        updateSlider(position);
    });

    // 初始化滑块位置
    updateSlider(currentPosition);
}

function getClientX(e) {
    return e.type.includes('touch') ?
        e.originalEvent.changedTouches[0].clientX : e.clientX;
}

function getClientY(e) {
    return e.type.includes('touch') ?
        e.originalEvent.changedTouches[0].clientY : e.clientY;
}

function initSlider(id) {
    const $slider = $(`#js_slider_${id}`);
    const $track = $slider.find('.noUi-connects');
    const $minHandle = $slider.find('[data-handle="0"]');
    const $maxHandle = $slider.find('[data-handle="1"]');

    // 创建自定义数据对象
    $slider.data('slider', {
        min: filterRange[id].min,
        max: filterRange[id].max,
        currentMin: filterRange[id].currentMin,
        currentMax: filterRange[id].currentMax,
        isDragging: false
    });

    // 更新显示位置
    function updatePositions() {
        const range = filterRange[id].max - filterRange[id].min;
        const minPos = ((filterRange[id].currentMin - filterRange[id].min) / range) * 100;
        const maxPos = ((filterRange[id].currentMax - filterRange[id].min) / range) * 100;

        $slider.find('.noUi-connect').css({
            'transform': `translate(${minPos}%, 0) scale(${(maxPos - minPos) / 100}, 1)`
        });

        const minPos1 = ((filterRange[id].currentMin - filterRange[id].max) / range) * 100;
        const maxPos1 = ((filterRange[id].currentMax - filterRange[id].max) / range) * 100;

        $slider.find('.noUi-origin').eq(0).css({
            'transform': `translate(${minPos1}%, 0)`
        });
        $slider.find('.noUi-origin').eq(1).css({
            'transform': `translate(${maxPos1}%, 0)`
        });
        $minHandle.attr('aria-valuenow', filterRange[id].currentMin);
        $maxHandle.attr('aria-valuenow', filterRange[id].currentMax);
        syncInputs()
    }

    // 同步输入框
    function syncInputs() {
        let min, minStr, max, maxStr
        if (id === 'price') {
            min = filterRange[id].currentMin = Math.ceil(filterRange[id].currentMin);
            max = filterRange[id].currentMax = Math.ceil(filterRange[id].currentMax);

            minStr = '$' + min.toLocaleString()
            maxStr = '$' + max.toLocaleString()
            $slider.parent().find('.js-filter-input').eq(0).val(minStr);
            $slider.parent().find('.js-filter-input').eq(1).val(maxStr);
        } else {
            if (typeof filterRange[id].step !== 'object') {
                min = filterRange[id].currentMin = Number(Number(filterRange[id].currentMin).toFixed(2));
                max = filterRange[id].currentMax = Number(Number(filterRange[id].currentMax).toFixed(2));
            } else {
                min = filterRange[id].currentMin
                max = filterRange[id].currentMax
            }
            minStr = min + (id.indexOf('_Per') > 0 ? '%' : '')
            maxStr = max + (id.indexOf('_Per') > 0 ? '%' : '')
            $slider.parent().find('.js-filter-input').eq(0).val(minStr);
            $slider.parent().find('.js-filter-input').eq(1).val(maxStr);
        }

        //搜索条件设置
        if (Number(max) !== filterRange[id].max || Number(min) !== filterRange[id].min) {
            let text = `${minStr} - ${maxStr}`
            if (typeof filterRange[id].step === 'object') {
                const step = typeof filterRange[id].stepName === 'object' ? filterRange[id].stepName : filterRange[id].step
                minStr = step[filterRange[id].currentMin + 0]
                maxStr = step[filterRange[id].currentMax - 1]
                if (minStr !== maxStr) {
                    text = `${minStr} - ${maxStr}`
                } else {
                    text = `${minStr}`
                }
            }

            const option = `<span class="item exposed-item exposed-item-${id}" data-vclass="${id}" data-text="${id}" data-filter_name="${id}">${text} ${filterNames[id]}<span class="x">x</span></span>`
            if ($('.exposed-filter').find(`.exposed-item-${id}`).length > 0) {
                $('.exposed-filter').find(`.exposed-item-${id}`).html(`${text} ${filterNames[id]}<span class="x">x</span>`)
            } else {
                $('.exposed-filter').append(option)
                $('.reset-button').show()
            }
        } else {
            if ($('.exposed-filter').find(`.exposed-item-${id}`).length > 0) {
                $(`.exposed-item-${id}`).trigger('click')
            }
        }

    }

    // 轨道点击处理
    $track.on('click', function (e) {
        const rect = this.getBoundingClientRect();
        const clickPos = (e.clientX - rect.left) / rect.width;
        const range = filterRange[id].max - filterRange[id].min;
        const targetValue = filterRange[id].min + (clickPos * range);
        const midPoint = (filterRange[id].currentMin + filterRange[id].currentMax) / 2;

        if (targetValue < filterRange[id].currentMin) {
            //小滑块往左
            filterRange[id].currentMin = Math.max(filterRange[id].min, targetValue);
            if (typeof filterRange[id].step === 'object') {
                filterRange[id].currentMin = Math.floor(filterRange[id].currentMin)
            }

        } else if (targetValue > filterRange[id].currentMax) {
            //大滑块往右
            filterRange[id].currentMax = Math.min(filterRange[id].max, targetValue);
            if (typeof filterRange[id].step === 'object') {
                filterRange[id].currentMax = Math.ceil(filterRange[id].currentMax)
            }
        } else {
            if (targetValue < midPoint) {
                //小滑块往右
                filterRange[id].currentMin = Math.min(targetValue, filterRange[id].currentMax);
                if (typeof filterRange[id].step === 'object') {
                    filterRange[id].currentMin = Math.min(Math.ceil(filterRange[id].currentMin), filterRange[id].currentMax - 1)
                }
            } else {
                //大滑块往左
                filterRange[id].currentMax = Math.max(targetValue, filterRange[id].currentMin);
                if (typeof filterRange[id].step === 'object') {
                    filterRange[id].currentMax = Math.max(Math.floor(filterRange[id].currentMax), filterRange[id].currentMin + 1)
                }
            }
        }

        updatePositions();
        triggerSliderUpdate(id);
    });

    // 手柄拖拽处理
    let temp_max = {}, temp_min = {};

    function handleDragStart(handle) {
        $slider.data('slider').isDragging = true;
        $(document).on('mousemove.slider touchmove', function (e) {
            if (!$slider.data('slider').isDragging) return;
            const rect = $track[0].getBoundingClientRect();
            const clientX = getClientX(e)
            const dragPos = (clientX - rect.left) / rect.width;
            const range = filterRange[id].max - filterRange[id].min;
            let targetValue = filterRange[id].min + (dragPos * range);

            let currentMin = Number(temp_min[id] || filterRange[id].min)
            let currentMax = Number(temp_max[id] || filterRange[id].max)

            if (handle === 'min') {
                if (typeof filterRange[id].step === 'object') {
                    if (targetValue > currentMin) {
                        targetValue = Math.ceil(targetValue)
                    } else {
                        targetValue = Math.floor(targetValue)
                    }
                    currentMax -= 1
                }
                filterRange[id].currentMin = Math.min(
                    Math.max(
                        filterRange[id].min,
                        Math.min(targetValue, filterRange[id].currentMax)
                    ),
                    currentMax);
            } else {
                if (typeof filterRange[id].step === 'object') {
                    if (targetValue > currentMax) {
                        targetValue = Math.ceil(targetValue)
                    } else {
                        targetValue = Math.floor(targetValue)
                    }
                    currentMin += 1
                }
                filterRange[id].currentMax = Math.max(
                    Math.min(
                        filterRange[id].max,
                        Math.max(targetValue, filterRange[id].currentMin)
                    ),
                    currentMin
                );
            }
            updatePositions();
        });

        $(document).one('mouseup touchend', function () {
            $slider.data('slider').isDragging = false;
            $(document).off('mousemove.slider touchmove');
            triggerSliderUpdate(id);
            temp_min[id] = Number(filterRange[id].currentMin)
            temp_max[id] = Number(filterRange[id].currentMax)
        });
    }

    $minHandle.on('mousedown touchstart', () => handleDragStart('min'));
    $maxHandle.on('mousedown touchstart', () => handleDragStart('max'));

    // 输入框处理
    $slider.parent().find('.js-filter-input').on('input', function () {
        const text = $(this).val().replace(/[^0-9.]/g, '')
        if (text.endsWith('.')) {
            return
        }
        const value = Number(text) || 0;
        if ($(this).hasClass('amount-min')) {
            if (value < filterRange[id].min || value > filterRange[id].max || value > filterRange[id].currentMax) {
                return;
            }
            filterRange[id].currentMin = Math.max(filterRange[id].min,
                Math.min(value, filterRange[id].currentMax));
        } else {
            if (value < filterRange[id].min || value < filterRange[id].currentMin || value > filterRange[id].max) {
                return;
            }
            filterRange[id].currentMax = Math.min(filterRange[id].max,
                Math.max(value, filterRange[id].currentMin));
        }

        updatePositions();
    }).on('blur', function () {
        triggerSliderUpdate(id)
    });

    // 初始化显示
    updatePositions();
}

// 触发更新事件
let updateTimer = {};
let applyTimer;
let filterRange, filterOptions, filterOptionsInit, filterNames

function triggerSliderUpdate(id) {
    if (updateTimer[id]) {
        clearTimeout(updateTimer[id]);
    }
    updateTimer[id] = setTimeout(() => {
        console.log(`${id} changed:`, {
            min: filterRange[id].currentMin,
            max: filterRange[id].currentMax
        });
        // 这里执行实际的过滤操作
        if (typeof filterRange[id].step === 'object') {
            const step = filterRange[id].step
            if (filterRange[id].currentMin !== filterRange[id].min || filterRange[id].currentMax !== filterRange[id].max) {
                filterOptions[id] = {}
                for (const index in step) {
                    if (index >= filterRange[id].currentMin && index <= filterRange[id].currentMax - 1) {
                        filterOptions[id][step[index]] = 1
                    }
                }
            }
        } else {
            filterOptions[id] = [filterRange[id].currentMin, filterRange[id].currentMax]
        }
        clearTimeout(applyTimer);
        applyTimer = setTimeout(() => {
            applyFilter()
        }, 100)
    }, 500);
}

// 动态设置范围
function setSliderRange(id, min, max) {
    filterRange[id].min = min;
    filterRange[id].max = max;
    filterRange[id].currentMin = min;
    filterRange[id].currentMax = max;
    $(`#js_slide_${id}`).data('slider', {
        min: min,
        max: max,
        currentMin: filterRange[id].currentMin,
        currentMax: filterRange[id].currentMax
    });
    initSlider(id); // 重新初始化
}

//动态设置值
function setSlider(id, currentMin, currentMax) {
    filterRange[id].currentMin = currentMin;
    filterRange[id].currentMax = currentMax;
    $(`#js_slide_${id}`).data('slider', {
        min: filterRange[id].min,
        max: filterRange[id].max,
        currentMin: filterRange[id].currentMin,
        currentMax: filterRange[id].currentMax
    });
    initSlider(id); // 重新初始化
    triggerSliderUpdate(id)
}

function initAllSlider() {
    for (const filter in filterRange) {
        initSlider(filter);
    }
}

function resetAllFilter() {
    filterOptions = JSON.parse(JSON.stringify(filterOptionsInit))
    for (const filter in filterRange) {
        filterRange[filter].currentMin = filterRange[filter].min
        filterRange[filter].currentMax = filterRange[filter].max
        setSlider(filter, filterRange[filter].min, filterRange[filter].max)
    }
}

function resetSliderFilter(filter, apply = true) {
    filterOptions[filter] = JSON.parse(JSON.stringify(filterOptionsInit[filter]))
    filterRange[filter].currentMin = filterRange[filter].min
    filterRange[filter].currentMax = filterRange[filter].max
    initSlider(filter)
    apply && applyFilter()
}

/* 滑动过滤器-end */


function toTitleCase(str) {
    return str.toLowerCase()              // 全转小写
        .split(' ')                          // 按空格分割为单词数组
        .map(word =>
            word.charAt(0).toUpperCase() +     // 首字母大写
            word.slice(1)                      // 保留剩余字母
        )
        .join(' ');                          // 重新组合为字符串
}

function changeMedia(mediaData) {
    mediaData.forEach((url, index) => {
        // 媒体元素处理
        if (index === 2) {
            for (let i = 1; i <= 192; i++) {
                const k = i.toString().padStart(3, '0')
                $(`.product-media-2-${k}`).attr('src', url.replace('.jpg', `_${k}.jpg`))
            }
        } else {
            $(`.product-media-${index}`).attr('src', url)
        }
    });
    $('.video-autoplay').each(function () {
        $(this)[0].play()
    })
}


$(document).on('click', '.view3d-icon', function () {
    window.open($(this).attr('data-href'), '_blank')
})

let shapeDiamondWH = {
    Heart: [500, 500],
    Princess: [500, 500],
    Asscher: [500, 500],
    Radiant: [500, 500],
    Emerald: [360, 500],
    Marquise: [280, 500],
    Cushion: [500, 500],
    Pear: [340, 500],
    Oval: [400, 500],
    Round: [500, 500],
}

/**
 * 根据钻石形状和克拉数计算背景尺寸百分比
 * @param {string} shape - 钻石形状 (如 'Round', 'Oval', 'Pear' 等)
 * @param {number} carat - 克拉数 (0.25-24)
 * @returns {[number, number]} - [宽度百分比, 高度百分比]
 */
function getDiamondBackgroundSize(shape, carat) {
    // 钻石尺寸数据表
    const sizeData = {
        Round: [[0.25, 22.23, 22.34], [0.5, 27.55, 27.72], [0.75, 31.25, 31.47], [1, 34.89, 35.22], [1.25, 37.55, 37.72], [1.5, 40.11, 40.27], [1.75, 42.07, 42.39], [2, 43.70, 43.97], [2.25, 45.00, 45.38], [2.5, 47.34, 47.61], [2.75, 48.70, 48.86], [3, 50.33, 50.43], [3.25, 50.98, 51.36], [3.5, 52.50, 52.61], [3.75, 54.08, 54.18], [4, 55.05, 55.43], [4.25, 56.90, 57.07], [4.5, 56.20, 56.74], [4.75, 58.97, 59.29], [5, 59.57, 59.95], [5.25, 61.03, 61.25], [5.5, 62.01, 62.39], [5.75, 62.77, 62.99], [6, 62.66, 63.21], [6.25, 63.64, 63.97], [6.5, 64.57, 64.84], [6.75, 66.41, 66.58], [7, 66.20, 66.63], [7.25, 67.55, 67.66], [7.5, 68.21, 68.59], [7.75, 69.13, 69.40], [8, 69.73, 69.89], [8.25, 70.27, 70.49], [8.5, 71.09, 71.52], [8.75, 71.20, 71.68], [9, 72.28, 72.61], [9.25, 72.99, 73.15], [9.5, 73.75, 74.18], [9.75, 74.24, 74.51], [10, 76.03, 76.68], [10.5, 76.25, 76.79], [11, 77.61, 77.88], [11.5, 78.97, 79.40], [12, 78.86, 79.62], [12.5, 79.95, 80.33], [13, 82.28, 82.77], [13.5, 82.55, 83.04], [14, 83.97, 84.46], [14.5, 85.65, 86.14], [15, 85.71, 86.20], [15.5, 86.85, 87.77], [16, 87.83, 88.21], [16.5, 89.51, 90.11], [17, 89.62, 89.95], [17.5, 90.82, 91.03], [18, 90.87, 91.09], [18.5, 92.23, 92.61], [19, 92.66, 92.88], [19.5, 93.70, 94.02], [20, 94.84, 95.54], [21, 95.60, 96.20], [22, 97.50, 97.88], [23, 98.48, 99.02], [24, 99.29, 99.73]],
        Oval: [[0.25, 19.73, 28.48], [0.5, 23.86, 35.27], [0.75, 27.61, 40.98], [1, 30.60, 43.21], [1.25, 32.99, 47.50], [1.5, 34.46, 50.87], [1.75, 37.34, 53.37], [2, 38.91, 55.49], [2.25, 39.18, 59.24], [2.5, 41.20, 60.00], [2.75, 43.15, 60.65], [3, 44.89, 62.88], [3.25, 44.62, 66.63], [3.5, 44.62, 69.84], [3.75, 47.07, 70.65], [4, 49.35, 70.11], [4.25, 49.13, 71.52], [4.5, 49.62, 74.29], [4.75, 51.14, 75.00], [5, 53.26, 73.04], [5.5, 54.24, 75.82], [6, 54.95, 78.42], [6.5, 56.36, 82.93], [7, 57.50, 85.49], [7.5, 59.95, 88.10], [8, 61.14, 86.03], [8.5, 61.47, 89.78], [9, 62.01, 97.88], [9.5, 64.73, 94.18], [10, 66.36, 93.80], [11, 65.76, 95.22], [12, 69.18, 99.78], [13, 72.83, 100.43], [14, 72.12, 102.66], [15, 73.26, 103.42], [16, 77.77, 111.03], [17, 79.02, 113.10], [18, 80.92, 117.45], [20, 81.85, 115.76], [21, 84.24, 121.14], [22, 85.54, 124.13], [23, 87.72, 125.33]],
        Pear: [[0.25, 19.29, 31.90], [0.5, 24.51, 37.72], [0.75, 27.28, 43.53], [1, 29.84, 48.04], [1.25, 32.72, 49.84], [1.5, 35.60, 53.04], [1.75, 36.58, 57.99], [2, 36.58, 57.99], [2.25, 39.46, 62.93], [2.5, 40.87, 65.54], [2.75, 42.50, 68.86], [3, 43.10, 69.13], [3.25, 44.46, 71.85], [3.5, 45.92, 80.38], [3.75, 46.25, 72.93], [4, 47.23, 75.49], [4.25, 50.00, 77.88], [4.5, 46.96, 80.87], [4.75, 51.85, 79.78], [5, 50.60, 85.33], [5.5, 54.35, 85.98], [6, 55.38, 88.70], [6.5, 57.93, 89.78], [7, 58.21, 93.86], [7.5, 58.42, 95.87], [8, 58.91, 101.14], [8.5, 61.74, 97.23], [9, 63.21, 104.62], [9.5, 64.35, 101.68], [10, 64.40, 108.75], [20, 82.61, 136.30]],
        Cushion: [[1, 29.46, 30.92], [1.25, 33.59, 34.78], [1.5, 34.57, 35.87], [1.75, 37.77, 38.70], [2, 38.15, 40.49], [2.25, 40.33, 41.74], [2.5, 41.79, 42.61], [2.75, 43.80, 43.91], [3, 45.11, 45.38], [3.25, 45.00, 46.52], [3.5, 47.72, 47.93], [3.75, 48.48, 48.97], [4, 47.99, 48.91], [4.25, 51.63, 52.28], [4.5, 51.63, 52.93], [4.75, 52.61, 53.59], [5, 53.42, 53.97], [5.5, 55.49, 56.20], [22, 82.07, 87.23]],
        Marquise: [[1, 27.88, 58.97], [1.25, 30.11, 61.03]],
        Emerald: [[1, 25.43, 35.76], [1.25, 28.10, 40.71], [1.5, 30.05, 42.55], [1.75, 30.71, 44.78], [2, 32.99, 47.66], [2.25, 33.64, 48.91], [2.5, 35.54, 48.64], [2.75, 35.71, 51.96], [3, 37.39, 52.88], [3.25, 37.17, 56.63], [3.5, 36.79, 57.66], [3.75, 38.59, 57.66], [4, 38.26, 59.24], [4.25, 41.41, 59.95]],
        Radiant: [[1, 26.90, 40.00], [1.25, 28.75, 42.07], [1.5, 29.89, 44.67], [1.75, 29.89, 44.67], [2, 33.48, 48.04], [2.25, 35.00, 49.67], [2.5, 35.00, 49.67], [2.75, 37.45, 55.05], [3, 38.91, 55.87], [3.25, 39.89, 56.09], [3.5, 39.78, 58.80], [3.75, 41.52, 59.84], [4, 42.83, 59.62], [4.25, 42.88, 64.46], [4.5, 44.18, 66.41], [4.75, 45.60, 64.35], [5, 45.76, 65.11], [15, 65.82, 92.72]],
        Asscher: [[1, 29.40, 29.46], [1.25, 32.23, 32.34], [1.5, 34.24, 34.35], [1.75, 35.76, 35.82], [2, 36.96, 37.50], [2.25, 38.48, 39.67], [2.5, 39.89, 40.49], [2.75, 42.34, 42.39], [3, 42.55, 42.93], [3.25, 42.55, 43.15], [3.5, 44.13, 44.78], [3.75, 46.63, 47.23], [4, 47.39, 47.61], [4.25, 47.50, 48.86], [4.5, 49.02, 49.62], [4.75, 50.00, 50.00], [5, 50.33, 50.38], [5.5, 50.87, 51.25], [6, 53.21, 54.40], [6.5, 55.27, 56.20], [7, 56.96, 57.45], [10, 61.58, 62.99], [19, 78.80, 79.95]],
        Princess: [[1, 29.29, 29.46], [1.25, 31.52, 32.50], [1.5, 33.53, 33.97], [1.75, 35.98, 36.25], [2, 36.96, 38.32], [2.25, 38.37, 38.64], [2.5, 40.00, 41.14], [2.75, 40.54, 42.07], [3, 42.45, 42.88], [3.25, 43.53, 43.70], [3.5, 43.70, 43.91], [3.75, 44.89, 46.74], [4, 46.20, 46.90], [4.25, 47.72, 48.04], [4.5, 49.13, 49.18], [4.75, 49.08, 49.57], [5, 49.73, 51.96], [5.5, 52.45, 53.32], [6, 52.45, 53.32], [6.5, 54.73, 55.16], [7, 55.54, 55.87]],
        Heart: [[1, 37.23, 34.08], [1.25, 39.67, 34.13], [1.5, 44.62, 37.07], [1.75, 46.58, 39.40], [2, 47.61, 41.14], [2.25, 49.35, 44.95], [2.5, 50.43, 47.23], [2.75, 53.97, 46.47], [3, 52.99, 48.26], [3.25, 55.27, 49.95], [3.5, 56.96, 51.90], [3.75, 58.53, 52.39], [4, 58.86, 54.57], [4.25, 61.47, 51.68], [4.5, 61.74, 54.13], [4.75, 64.51, 56.85], [5, 65.49, 56.63]]
    }


    // 检查形状是否支持
    if (!sizeData[shape]) {
        console.warn(`不支持的形状: ${shape}, 使用默认值`);
        return [50, 50];
    }

    const data = sizeData[shape];

    // 对数据按克拉数排序
    data.sort((a, b) => a[0] - b[0]);

    // 边界检查
    if (carat <= data[0][0]) return [data[0][1], data[0][2]];
    if (carat >= data[data.length - 1][0]) {
        return [data[data.length - 1][1], data[data.length - 1][2]];
    }

    // 查找最近的2个数据点
    let prev = data[0];
    let next = data[1];

    for (let i = 1; i < data.length; i++) {
        if (carat <= data[i][0]) {
            prev = data[i - 1];
            next = data[i];
            break;
        }
    }

    // 线性插值计算
    const ratio = (carat - prev[0]) / (next[0] - prev[0]);
    const width = prev[1] + ratio * (next[1] - prev[1]);
    const height = prev[2] + ratio * (next[2] - prev[2]);
    return [width, height];
}


function initMedia(mediaData, selector = '#show-product-images', iframeInitImg = '', v360Icon = '', diamondInfo = {}) {
    // 创建 DOM 片段优化性能
    // const fragment = document.createDocumentFragment();
    let hasVideo = false
    let canPlay = false
    mediaData.forEach((url, index) => {
        canPlay = false;
        hasVideo = false
        // 媒体元素处理
        let thumb_url = url + '';
        if (url.indexOf('.mp4') > -1) { // 视频
            canPlay = true
            const html = `
<div class="flex-two-colunm ir328-gallery-img swiper-slide swiper-slide-${index}">
    <div class="intrinsic-ratio intrinsic-ratio-1-1 zoom-wrap">
        <div class="element-to-stretch">
            <div class="top_lg photo img-container" style="position: relative; overflow: hidden;">
                <div class="zoom-element--double">
                    <video class="video-autoplay product-media-${index}"
                        autoplay loop muted playsInline controls
                        style="width:100%;height:100%;object-fit:cover;"
                    >
                    <source type="video/mp4" src="${url}">
                    </video>
                </div>
            </div>
            <style>
                .video-autoplay::-webkit-media-controls { display:none !important; }
                .video-autoplay::-webkit-media-controls-enclosure { width:0; height:0; }
            </style>
        </div>
    </div>
</div>
`
            hasVideo = true
            $(selector).append(html)
        }

        if (url.indexOf('_3.jpg') > -1) { // 多图片模拟视频
            canPlay = true
            url = url.replace('.jpg', '')
            let lis = '';
            thumb_url = `${url}_001.jpg`
            for (let i = 1; i <= 192; i++) {
                const k = i.toString().padStart(3, '0')
                lis += `<li style="display: none; ">
                    <img alt="" class="product-media-2-${k}" data-ordial="1" data-source="${k}.jpg" data-extra-view="false" data-width="720"
                         data-height="720" data-aspect-ratio="1" data-retries="0"
                         src="${url}_${k}.jpg"
                         data-loaded="true"
                         style="margin-left: auto; margin-right: auto; width: 100%; height: 100%; object-fit: cover;"/>
                     </li>
`
            }
            const html = `
<div class="flex-two-colunm ir328-gallery-img swiper-slide swiper-slide-${index}">
    <div class="intrinsic-ratio intrinsic-ratio-1-1 zoom-wrap">
        <div class="element-to-stretch">
            <div class="top_lg photo img-container" style="position: relative; overflow: hidden;">
                <div class="zoom-element--double zoom-video-images" id="${selector.replace('#', '').replace('.', '')}-zoom-video-images-${index}">
                    <ol class="rotato" style="display: block; width: 100%; height: 100%; padding: 0; margin: 0">
                        ${lis}
                    </ol>
                </div>
            </div>
        </div>
    </div>
</div>
`
            $(selector).append(html)
        } else if (url.indexOf('view.html?d=') > -1 || url.indexOf('detail.html?d=') > -1) { // iframe
            canPlay = true
            thumb_url = iframeInitImg
            const html = `
<div class="flex-two-colunm ir328-gallery-img swiper-slide swiper-slide-${index}">
    <div class="intrinsic-ratio intrinsic-ratio-1-1 zoom-wrap">
        <div class="element-to-stretch">
            <div class="top_lg photo img-container">
                <div class="v360-show">
                    <div class="v360-show-img" style="">
                        <img style="width: 100%; position: absolute; z-index: 4;" class="smimg" src="${iframeInitImg}">
                    </div>
                    <div class="v360-show-video iframe-lazyload">
                        <div class="view3d-icon" data-href="${url}" style="position: absolute; right: 8px; top: 8px; opacity: 0.7; z-index: 10; width: 30px;height: 30px; border-radius: 50%; border: 1px solid #dddddd; cursor: pointer;">
                            <img src='${v360Icon}' width="15" height="15">
                        </div>
                        <iframe class="v360-iframe iframe-video" src="${iframeInitImg}" id="product-video1-${url}" video-url="${url}" img-url="${iframeInitImg}" style="width: 100%; height: 200%; border: medium none; overflow: hidden; z-index: 5; position: absolute;"></iframe>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
`
            $(selector).append(html)
        } else if (url.indexOf('design-custom-zoom-') > -1) {
            canPlay = false
            thumb_url = '/cdn/shop/t/10/assets/design-custom-diamond-hand-light.jpg'
            const [width, height] = getDiamondBackgroundSize(diamondInfo.Shape, diamondInfo.Weight);
            const html = `
            <div class="swiper-slide">
                    <div class="tm-relative">
                      <div class="tm-absolute tm-right-2 tm-top-1/2 tm-flex tm-h-52 -tm-translate-y-1/2 tm-flex-col tm-items-center tm-justify-center tm-gap-3 tm-text-xs tm-z-20">
                          <div>Darker</div>
                          <div class="nouislider-pro nouislider-touch-area tm-flex-1 !tm-bg-lightGreen noUi-target noUi-ltr noUi-vertical noUi-txt-dir-ltr js_slider_hand">
                            <div class="noUi-base">
                                <div class="noUi-connects"></div>
                                <div class="noUi-origin" style="transform: translate(0px, 100%); z-index: 4;">
                                    <div class="noUi-handle noUi-handle-lower" data-handle="0" tabindex="0" role="slider" aria-orientation="vertical" aria-valuemin="0.0" aria-valuemax="1.0" aria-valuenow="1.0" aria-valuetext="1.00">
                                        <div class="noUi-touch-area">
                                        </div>
                                    </div>
                                </div>
                            </div>
                          </div>
                          <div>Lighter</div>
                      </div>
                      <div class="tm-relative">
                        <img src="/cdn/shop/t/10/assets/design-custom-diamond-hand-light.jpg" class="light-base-hand img-responsive" alt="light hand">
                        <img src="/cdn/shop/t/10/assets/design-custom-diamond-hand-dark.jpg" class="dark-base-hand img-responsive tm-absolute tm-inset-0" style="opacity: 0;" alt="dark hand">
                        <img src="/cdn/shop/t/10/assets/design-custom-diamond-hand-dark2.jpg" class="dark-base-hand2 img-responsive tm-absolute tm-inset-0" style="opacity: 0;" alt="dark hand2">
                        <span class="tm-absolute tm-left-1/2 tm-top-1/2 tm-z-20 tm-h-2/5 tm-w-2/5 tm-bg-center tm-bg-no-repeat" style="left: 25%;margin-top: -18%; background-image:url(${url}); background-size:${width}% ${height}%;"></span>
                      </div>
                    </div>
                  <p class="tm-absolute tm-z-20 tm-left-0 tm-right-0 tm-bottom-2 tm-text-center tm-text-xs tm-mb-0 explain">Actual Diamond Size on Size 6 Hand</p>
                </div>
                <script>
                $(document).ready(function () {
                    initSliderHand('.js_slider_hand')
                })
</script>
            `
            $(selector).append(html)
        } else if (url.indexOf('-Top.png') > -1) {
            canPlay = false
            const parts = diamondInfo.Measurement.split(/[-*]/).map(part => part.trim());
            const [length, width, height] = parts.map(parseFloat);

            const html = `
<div class="flex-two-colunm ir328-gallery-img swiper-slide swiper-slide-${index}">
    <div class="intrinsic-ratio intrinsic-ratio-1-1 zoom-wrap">
        <div class="top_lg photo img-container">
            <div class="" style="position: relative">
                <span class="tm-absolute tm-min-w-14 -tm-translate-x-1/2 -tm-translate-y-1/2 tm-bg-white tm-text-[11px]" style="top: 28.3%; left: 32.3%">Length: ${length}mm</span>
                <span class="tm-absolute tm-w-20 -tm-translate-x-1/2 -tm-translate-y-1/2 tm-bg-white tm-text-[11px]" style="top: 59.5%; left: 50%">Width: ${width}mm</span>
                <img class="tm-w-full" src="${url}" alt="diamond measurements">
          </div>
        </div>
    </div>
</div>
                
            `
            $(selector).append(html)
        } else if (url.indexOf('-Side.png') > -1) {
            canPlay = false
            const parts = diamondInfo.Measurement.split(/[-*]/).map(part => part.trim());
            const [length, width, height] = parts.map(parseFloat);
            const html = `
<div class="flex-two-colunm ir328-gallery-img swiper-slide swiper-slide-${index}">
    <div class="intrinsic-ratio intrinsic-ratio-1-1 zoom-wrap">
        <div class="top_lg photo img-container">
            <div class="" style="position: relative" >
                <span class="tm-absolute tm-min-w-14 tm-translate-y-1/4 tm-bg-white tm-text-[11px]" style="top: 16.3%; left: 43.5%">Table: ${diamondInfo.Table_Diameter_Per}%</span>
                <span class="tm-absolute tm-w-20 tm-translate-y-1/2 tm-bg-white tm-text-[11px]" style="top: 69.6%; left: 7.8%">Girdle: ${diamondInfo.Girdle}</span>
                <span class="tm-absolute tm-w-20 tm-translate-y-1/2 tm-bg-white tm-text-[11px]" style="top: 84.8%; left: 43.5%">Culet: ${diamondInfo.CuletSize}</span>
                <span class="tm-absolute tm-translate-x-1/5 tm-bg-white tm-text-[11px]" style="top: 60.9%; left: 80.4%">Depth: ${diamondInfo.Total_Depth_Per}%<br>${height}mm</span>
                <img class="tm-w-full" src="${url}" alt="diamond measurements">
            </div>
        </div>
    </div>
</div>
                
            `
            $(selector).append(html)
        } else {
            canPlay = false
            // 图片处理
            let zoomDivClassName, zoomDivStyle, photoDivStyle, imgStyle;
            if (url.indexOf('cert_') > -1) { //证书
                zoomDivClassName = 'zoom-element--double certImage';
                zoomDivStyle = 'display: flex; align-items: center; height: 100%'
                photoDivStyle = 'position: relative; overflow: hidden; height: 100%';
                $('body').append(`<div class="modal fade modal-slider-tips in acsb-active certImage-dialog" data-url="${url}" role="dialog" data-acsb-hidden="false" style="display: none; z-index: 9999" data-acsb-overlay="popup" aria-modal="true" aria-label="Popup" tabindex="-1">
  <div class="modal-dialog tm-pointer-events-none tm-flex tm-min-h-[calc(100%-20px)] tm-items-center lg:tm-w-[800px]" style="width: 80%;">
    <div class="tm-pointer-events-auto tm-relative tm-w-full tm-bg-white tm-shadow">
      <div class="certImage-dialog-close tm-absolute tm-right-0 tm-top-0 tm-z-20 tm-appearance-none tm-border-none tm-bg-transparent tm-p-3" data-dismiss="modal" type="button" aria-hidden="true" data-acsb-clickable="true" data-acsb-navigable="true" data-acsb-now-navigable="true" data-custom-button-processed="true" data-acsb-textual-ops="close">
        <svg class="tm-block" fill="none" height="25" viewBox="0 0 24 25" width="24" xmlns="http://www.w3.org/2000/svg" aria-hidden="true" data-acsb-hidden="true">
          <path d="M6 18.3499L12.0015 12.3499M12.0015 12.3499L18 6.34985M12.0015 12.3499L6 6.34985M12.0015 12.3499L18 18.3499" stroke="#2C2C2C" stroke-linecap="square" stroke-linejoin="round" stroke-width="1.5" style="display: block;"></path>
        </svg>
      </div>
      <div class="tm-py-12">
        <img id="cert-img" class="tm-w-full" src="${url}" alt="Diamond Certificate Image">
      </div>
    </div>
  </div>
</div>`)
                imgStyle = 'margin-left: auto; margin-right: auto; width: 100%; object-fit: cover;';
            } else {
                zoomDivClassName = 'zoom-element--double zoomImage';
                imgStyle = 'margin-left: auto; margin-right: auto; width: 100%; height: 100%; object-fit: cover;';
            }

            const html = `
<div class="flex-two-colunm ir328-gallery-img swiper-slide swiper-slide-${index}">
    <div class="intrinsic-ratio intrinsic-ratio-1-1 zoom-wrap">
        <div class="top_lg photo img-container">
            <div class="${zoomDivClassName}">
                <img 
                    src="${url}"
                    loading="${index > 1 ? 'lazy' : 'eager'}"
                    alt=""
                    class="img-responsive lazyload product-media-${index}"
                    style="${imgStyle}" 
                />
            </div>
        </div>
    </div>
</div>
`
            $(selector).append(html)
        }


        if (selector === '.swiper-wrapper') {
            const playIcon = canPlay ? `<svg class="tm-transform tm-absolute tm-left-1/2 tm-top-1/2 -tm-translate-x-1/2 -tm-translate-y-1/2" fill="none" height="22" viewBox="0 0 22 22" width="22" xmlns="http://www.w3.org/2000/svg">
            <circle cx="11" cy="11" fill="#2C2C2C" fill-opacity="0.9" r="11"></circle>
            <path d="M8 17V6L17 11.5L8 17Z" fill="white" fill-opacity="0.9"></path>
            </svg>` : '';
            $('.swiper-thumbs').append(`
<div class="swiper-slide tm-h-15 tm-border-normal tm-w-14 tm-border-b-[3px] tm-border-b-transparent tm-pb-px [&amp;.swiper-slide-thumb-active]:tm-border-b-lightGreen ${index === 0 ? 'swiper-slide-thumb-active' : ''}" data-eq="${index}">
    ${playIcon}
    <img class="tm-w-full product-media-${index}" data-caption="top" src="${thumb_url}" alt="thumbnail">
</div>
`)
        }
    });

    if (hasVideo) {
        $('.video-autoplay').each(function () {
            $(this)[0].play()
        })
    }
}

function getNextSibling(selector) {
    // 获取当前激活元素
    const activeElement = $(selector);

    // 获取下一个兄弟元素
    let nextElement = activeElement.next();

    // 如果没有下一个兄弟元素（已经是最后一个）
    if (nextElement.length === 0) {
        // 获取第一个兄弟元素
        nextElement = activeElement.siblings().first();
    }

    return nextElement;
}

$(document).ready(function () {
    // 初始化变量记录触摸位置
    let touchStartX = 0;
    let touchStartY = 0;
    let lastMoveX = 0;
    let lastMoveY = 0;
    let swiperSliders = null;
    let total = 0;
    const $swiper = $('.swiper-container');
    if ($swiper.length >= 0) {
        $swiper.on('touchstart', function (e) {
            const touch = e.originalEvent.touches[0];
            touchStartX = touch.clientX;
            touchStartY = touch.clientY;
            lastMoveX = touchStartX;
            lastMoveY = touchStartY;

            swiperSliders = $(this).parent().find('.swiper-slide-thumb-active').siblings().addBack();
            total = swiperSliders.length
        });

        // 绑定触摸结束事件
        $swiper.on('touchend', function (e) {
            const touch = e.originalEvent.changedTouches[0];
            const currentX = touch.clientX;
            const currentY = touch.clientY;

            // 计算移动距离
            const deltaX = currentX - lastMoveX;
            const deltaY = currentY - lastMoveY;

            // 更新最后位置
            lastMoveX = currentX;
            lastMoveY = currentY;

            // 计算总移动距离
            const totalDeltaX = currentX - touchStartX;
            const totalDeltaY = currentY - touchStartY;

            // 判断滑动方向
            if (Math.abs(totalDeltaX) > Math.abs(totalDeltaY)) {
                let eq = getActiveSlideIndexIncludingSelf(swiperSliders.parent().find('.swiper-slide-thumb-active'))
                // 水平滑动
                if (deltaX < 0) {
                    // 右滑
                    eq += 1
                    if (eq >= total) {
                        eq = 0
                    }
                } else if (deltaX > 0) {
                    // 左滑
                    eq -= 1
                    if (eq < 0) {
                        eq = total - 1
                    }
                }
                swiperSliders.eq(eq).trigger('click');
            }

            // 重置触摸位置
            touchStartX = 0;
            touchStartY = 0;
            lastMoveX = 0;
            lastMoveY = 0;
        });
    }
})

function getActiveSlideIndexIncludingSelf(activeElement) {
    const allSiblings = activeElement.siblings().addBack();

    // 排序所有兄弟元素（包括自身）
    const sortedSiblings = allSiblings.sort(function (a, b) {
        return $(a).index() - $(b).index();
    });

    // 获取当前激活元素在排序后的位置
    return sortedSiblings.index(activeElement);
}

class VideoFrameSlider {
    constructor(container) {
        this.$container = $(container);
        this.$list = this.$container.find('.rotato');
        this.frames = this.$list.children('li').toArray();
        this.frameCount = this.frames.length;

        // 动画控制
        this.currentIndex = 0;
        this.direction = 1;
        this.baseSpeed = 60;
        this.currentSpeed = this.baseSpeed;
        this.lastFrameTime = 0;
        this.animationId = null;

        // 拖拽参数
        this.isDragging = false;
        this.dragSensitivity = 4; // 每8px切换1帧
        this.minSpeed = 30;     // 最快播放速度(ms)
        this.decelerationFactor = 0.91;
        this.remainingSpeedTime = 0;
        this.dragVelocity = 0;

        // 初始化
        this.initDom();
        this.bindEvents();
        this.startAnimation();
    }

    initDom() {
        $(this.frames).hide().eq(0).show();
        this.$container.css('user-select', 'none');
    }

    bindEvents() {
        this.$container.on({
            'mousedown touchstart': e => this.startDrag(e),
            'mouseleave touchend': () => this.endDrag()
        });

        $(document)
            .on('mousemove touchmove', e => this.handleDrag(e))
            .on('mouseup touchend', () => this.endDrag());
    }

    // 核心动画循环
    animate(timestamp) {
        if (!this.lastFrameTime) this.lastFrameTime = timestamp;
        const delta = timestamp - this.lastFrameTime;

        if (this.remainingSpeedTime > 0) {
            this.remainingSpeedTime -= 1;
            if (this.remainingSpeedTime <= 0) {
                this.dragVelocity = 0;
            }
        }

        if (!this.isDragging) {
            const frameInterval = this.currentSpeed + this.dragVelocity * 50;
            if (delta >= frameInterval) {
                this.advanceFrame();
                this.lastFrameTime = timestamp;
                this.currentSpeed = Math.max(
                    this.minSpeed,
                    this.currentSpeed * this.decelerationFactor
                );
            }
        }

        this.animationId = requestAnimationFrame(t => this.animate(t));
    }

    advanceFrame() {
        this.currentIndex = (this.currentIndex + this.direction + this.frameCount) % this.frameCount;
        this.updateFrameDisplay();
    }

    updateFrameDisplay() {
        this.frames.forEach((frame, i) => {
            frame.style.display = i === this.currentIndex ? 'block' : 'none';
        });
    }

    // 拖拽控制
    startDrag(e) {
        e.preventDefault();
        this.isDragging = true;
        this.startX = this.getEventX(e);
        this.lastDragX = this.startX;
        this.lastDragTime = Date.now();
        cancelAnimationFrame(this.animationId);
    }

    handleDrag(e) {
        if (!this.isDragging) return;

        const currentX = this.getEventX(e);
        const deltaX = currentX - this.startX;
        const frameDelta = Math.round(deltaX / this.dragSensitivity);

        // 方向校准
        if (deltaX > 0) {
            this.direction = -1;
        } else if (deltaX < 0) {
            this.direction = 1;
        }
        const actualMovement = frameDelta * -1;

        if (actualMovement !== 0) {
            this.currentIndex += actualMovement;
            this.currentIndex = (this.currentIndex + this.frameCount) % this.frameCount;
            this.updateFrameDisplay();
            this.startX = currentX - (deltaX % this.dragSensitivity);
        }

        this.trackVelocity(currentX);
        this.adjustSpeedByVelocity();
    }

    trackVelocity(currentX) {
        const now = Date.now();
        const timeDelta = now - this.lastDragTime;
        const moveDelta = currentX - this.lastDragX;

        if (timeDelta > 0) {
            this.dragVelocity = moveDelta / timeDelta; // px/ms
            this.lastDragX = currentX;
            this.lastDragTime = now;
        }
    }

    adjustSpeedByVelocity() {
        const speedFactor = Math.abs(this.dragVelocity) * 50;
        this.currentSpeed = Math.max(
            this.minSpeed,
            this.baseSpeed - speedFactor * 15
        );
    }

    endDrag() {
        if (!this.isDragging) return;
        this.isDragging = false;

        this.remainingSpeedTime = 5; // 维持当前速度1秒
        this.startAnimation();
        this.lastFrameTime = 0;
    }

    getEventX(e) {
        return e.type.startsWith('touch') ?
            e.originalEvent.touches[0].clientX :
            e.clientX;
    }

    startAnimation() {
        this.animationId = requestAnimationFrame(t => this.animate(t));
    }
}


// 生成图片和视频
$(document).ready(function () {
    if ($('.zoom-video-images').length > 0) {
        $('.zoom-video-images').each(function () {
            const id = $(this).attr('id')
            new VideoFrameSlider($(`#${id}`));
        })
    }

    let iframeTimer = {};
    const iframeObserver = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
            let iframe = entry.target;
            if (entry.isIntersecting) {
                iframe.src = $(iframe).attr('video-url');
                iframeObserver.unobserve(iframe);
                clearTimeout(iframeTimer[iframe.id])
                iframeTimer[iframe.id] = setTimeout(function () {
                    iframe.parentElement.classList.remove('iframe-lazyload');
                }, 4000)
            } else {
                // iframe.src = $(iframe).attr('img-url');
                // iframe.parentElement.classList.add('iframe-lazyload');
            }
        });
    });
    if (isMobile) {
        $('.v360-iframe').attr('src', $('.v360-iframe').attr('video-url')).parent().removeClass('iframe-lazyload');
        $('.view3d-icon').remove()
    } else {
        document.querySelectorAll('.v360-iframe').forEach(iframe => iframeObserver.observe(iframe))
    }

    /* 视频控制-start */
    const $video = $('.video-autoplay');
    let isDragging = false,
        startX = 0,
        startTime = 0,
        wasPaused = true;

    // 获取标准化时间
    function getLoopTime(time, duration) {
        return ((time % duration) + duration) % duration;
    }

    // 拖拽开始
    function handleStart(e) {
        isDragging = true;
        startX = e.type.includes('touch') ?
            e.originalEvent.touches[0].pageX : e.pageX;
        startTime = $video[0].currentTime;
        wasPaused = $video[0].paused;
        $video.prop('controls', false);
        $video[0].pause();
    }

    // 拖拽中 (核心逻辑)
    function handleMove(e) {
        if (!isDragging) return;

        const currentX = e.type.includes('touch') ?
            e.originalEvent.touches[0].pageX : e.pageX;
        const deltaX = currentX - startX;
        const duration = $video[0].duration;

        // 计算时间变化量 (0.3为灵敏度系数)
        const timeDelta = deltaX * 0.3;
        let newTime = startTime - timeDelta;

        // 循环时间计算
        newTime = getLoopTime(newTime, duration);

        // 更新视频进度
        $video[0].currentTime = newTime;
    }

    // 拖拽结束
    function handleEnd() {
        isDragging = false;
        $video.prop('controls', true);

        // 恢复原始播放状态
        $video[0].play();
    }

    // 事件绑定
    $video.on('mousedown touchstart', handleStart);
    $(document)
        .on('mousemove touchmove', '.video-autoplay', handleMove)
        .on('mouseup touchend', '.video-autoplay', handleEnd);
    /* 视频控制-end */

    /* 图片控制-start */
    // 为每个图片容器初始化
    $('.img-container:has(.zoomImage)').each(function () {
        const $container = $(this);
        const $image = $container.find('.zoomImage');
        let isZoomed = false;

        // 计算位移
        function calculateOffset(e) {
            const containerWidth = $container.width();
            const containerHeight = $container.height();

            // 鼠标相对容器的百分比位置
            const mouseX = (e.pageX - $container.offset().left) / containerWidth;
            const mouseY = (e.pageY - $container.offset().top) / containerHeight;

            // 计算偏移量 (基于放大后的尺寸)
            const offsetX = (850 - containerWidth) * mouseX;
            const offsetY = (850 - containerHeight) * mouseY;

            return {x: -offsetX, y: -offsetY};
        }

        // 图片位置更新
        function updatePosition(e) {
            if (!isZoomed) return;

            const offset = calculateOffset(e);
            $image.css({
                width: '850px',
                height: '850px',
                transform: `translate(${offset.x}px, ${offset.y}px)`
            });
        }

        // 切换缩放状态
        function toggleZoom(e) {
            if (isZoomed) {
                $image.css({
                    width: 'unset',
                    height: 'unset',
                    'transform': 'none',
                });
                $container.css({
                    width: 'unset',
                    height: 'unset',
                })
                $container.removeClass('zoomed');
            } else {
                const offset = calculateOffset(e);
                $container.css({
                    width: $container.width() + 'px',
                    height: $container.height() + 'px',
                })
                $image.css({
                    width: '850px',
                    height: '850px',
                    transform: `translate(${offset.x}px, ${offset.y}px)`
                });
                $container.addClass('zoomed');
            }
            isZoomed = !isZoomed;
        }

        // 事件绑定
        $container.on({
            click: toggleZoom,
            mousemove: updatePosition,
            mouseleave: function () {
                if (isZoomed) toggleZoom();
            }
        });
    });
    /* 图片控制-end */

    $('.certImage').click(function () {
        const src = $(this).find('img').attr('src');
        $(`.certImage-dialog[data-url='${src}']`).show()
    })
    $('.certImage-dialog-close').click(function () {
        $(this).parent().parent().parent().hide()
    })

    $('.view-setting').click(function () {
        localStorage.removeItem('selectedRingSetting1');
        window.open($(this).attr('data-url'), '_self')
    })
    $('.change-setting').click(function () {
        localStorage.removeItem('selectedRingSetting1');
        window.open($(this).attr('data-url'), '_self')
    })
    $('.view-diamond').click(function () {
        localStorage.removeItem('selectedRingDiamond');
        window.open($(this).attr('data-url'), '_self')
    })
    $('.change-diamond').click(function () {
        localStorage.removeItem('selectedRingDiamond');
        window.open($(this).attr('data-url'), '_self')
    });

    $('.swiper-thumbs').find('.swiper-slide').click(function () {
        $(this).addClass('swiper-slide-thumb-active').siblings().removeClass('swiper-slide-thumb-active');
        const eq = Number($(this).attr('data-eq'));
        const $bigImage = $(`.swiper-slide-${eq}`)
        $bigImage.addClass('swiper-slide-active').siblings().removeClass('swiper-slide-active');
        const width = -getActiveSlideIndexIncludingSelf($(this)) * $(this).parent().parent().parent().find('.swiper-wrapper').width();
        $(`.swiper-wrapper`).css('transform', `translate3d(${width}px, 0px, 0px)`)
    })


    const observer = new MutationObserver(function (mutations) {
        mutations.forEach(function (mutation) {
            if (mutation.addedNodes.length) {
                $(mutation.addedNodes).each(function () {
                    if ($(this).attr('data-action-quickview') !== undefined) {
                        $(this).removeAttr('data-action-quickview')
                    }
                    if ($(this).attr('data-action-quickshop') !== undefined) {
                        $(this).remove()
                    }
                    if ($(this).attr('data-action-atc') !== undefined) {
                        $(this).remove()
                    }
                });
            }
        });
    });

    document.querySelectorAll('.recommend-product-lists').forEach(recommend => observer.observe(recommend, {
        childList: true,
        subtree: true
    }))
})

